﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

//-------------------------------------------------------------------------------------
// Exports
//-------------------------------------------------------------------------------------

export enum CustomerStartPageTab {
    StartNewSession = "SoPNL.UI.CustomerStartPage.Tab.StartNewSession",
    ResumeSessions = "SoPNL.UI.CustomerStartPage.Tab.ResumeSessions",
}

export enum CustomerStartPageSessionFilter {
    All = "All",
    Incomplete = "Incomplete",
    Complete = "Complete",
}

export const NUM_PREV_SESSIONS_PER_PAGE = 5;
